import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Illustrations-2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1125",
					d: "M87.4976 24.5021C68.062 42.8068 62.8206 56.6083 47.1726 64.8731C37.2226 70.1285 25.767 73.9868 19.8893 83.5823C-1.51919 118.532 44.1152 147.28 73.4972 113C98.4156 83.9275 136.624 151.34 172.997 96.5C205.496 47.5007 138.997 -24.0008 87.4976 24.5021Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 3464084",
					x: 51,
					y: 48,
					width: 98,
					height: 60,
					rx: 4,
					fill: "url(#paint0_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 3464087",
					x: 62,
					y: 30,
					width: 76,
					height: 51,
					rx: 4,
					fill: "url(#paint1_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 3464085",
					d: "M51 51.5696C51 50.007 52.7116 49.0479 54.0443 49.8639L142.947 104.294C144.669 105.349 143.922 108 141.903 108H55C52.7909 108 51 106.209 51 104V51.5696Z",
					fill: "url(#paint2_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 3464086",
					d: "M149 51.5696C149 50.007 147.288 49.0479 145.956 49.8639L54.0263 106.147C53.1654 106.674 53.539 108 54.5485 108H145C147.209 108 149 106.209 149 104V51.5696Z",
					fill: "url(#paint3_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 3464088",
					x: 76,
					y: 42,
					width: 39,
					height: 4,
					rx: 2,
					fill: "url(#paint4_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 3464089",
					x: 76,
					y: 53,
					width: 26,
					height: 4,
					rx: 2,
					fill: "url(#paint5_linear_160_1400)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 592",
					cx: 92,
					cy: 122,
					r: 6,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 593",
					cx: 39,
					cy: 34,
					r: 8,
					fill: "#F0FAF8"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_160_1400",
				x1: 54.7373,
				y1: 51.0508,
				x2: 102.084,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_160_1400",
				x1: 64.8983,
				y1: 32.5932,
				x2: 106.743,
				y2: 95.5446,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_160_1400",
				x1: 54.7373,
				y1: 51.0508,
				x2: 102.084,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_160_1400",
				x1: 145.263,
				y1: 51.0508,
				x2: 97.9157,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_160_1400",
				x1: 77.4873,
				y1: 42.2034,
				x2: 78.2032,
				y2: 49.2496,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_160_1400",
				x1: 76.9915,
				y1: 53.2034,
				x2: 78.0518,
				y2: 60.1608,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
